import { render, staticRenderFns } from "./Landings.vue?vue&type=template&id=44c68b0b"
import script from "./Landings.vue?vue&type=script&lang=js"
export * from "./Landings.vue?vue&type=script&lang=js"
import style0 from "./Landings.vue?vue&type=style&index=0&id=44c68b0b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports